import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { insuranceNoticeListResource, configInsuranceNoticeTemplate, insuranceNoticeConfigList } from './request';
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      templateOptions: [],
      formData: {
        selectedTemplates: [],
        userId: null
      },
      rules: {
        selectedTemplates: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择模板')
        }]
      }
    };
  },
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    cancelFunc() {
      this.dialogVisible = false;
      this.formData = {
        selectedTemplates: [],
        userId: null
      };
      this.$emit('cancel');
    },
    async init() {
      //   this.formData.userId = userId;
      this.dialogVisible = true;
      await this.fetchTemplateOptions();
      await this.getInsuranceNoticeConfigList();
    },
    async fetchTemplateOptions() {
      try {
        const res = await insuranceNoticeListResource({});
        console.log(res, 'fetchTemplateOptions');
        this.templateOptions = res || [];
      } catch (error) {
        this.$message.error(this.$t('获取模板列表失败'));
      }
    },
    async getInsuranceNoticeConfigList() {
      try {
        console.log(this.row.id, 'getInsuranceNoticeConfigList');
        const res = await insuranceNoticeConfigList({
          userId: this.row.id
        });
        console.log(res, 'getInsuranceNoticeConfigList');
        this.formData.selectedTemplates = res && res.map(item => item.noticeTemplateId) || [];
      } catch (error) {
        this.$message.error(this.$t('获取模板配置失败'));
      }
    },
    handleSure() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          try {
            if (this.loading) return;
            this.loading = true;
            let params = {
              userId: this.row.id,
              noticeTemplateIds: this.formData.selectedTemplates.join(',')
            };
            console.log(params, 'handleSure');
            await configInsuranceNoticeTemplate(params);
            this.$message.success(this.$t('操作成功'));
            this.$emit('ok');
            this.cancelFunc();
          } catch (error) {
            this.$message.error(this.$t('保存失败'));
          } finally {
            this.loading = false;
          }
        }
      });
    }
  }
};